// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".unverifiedBlocker__dACrQ {\n  background: #f6f6f6;\n  height: 100vh;\n  left: 0;\n  position: fixed;\n  top: 0;\n  width: 100vw;\n  z-index: 1000;\n}\n\n.card__3DR58 {\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  margin: auto;\n  margin-top: 60px;\n  max-width: 440px;\n}\n\n.logo__2Z_t4 svg {\n  height: 60px;\n  width: 240px;\n}\n\n.title__2nGWn {\n  font-weight: 400;\n  font-size: 23px;\n  margin-top: 5px;\n}\n\n.body__3VArq {\n  margin: 0;\n  text-align: center;\n}", ""]);
// Exports
exports.locals = {
	"unverifiedBlocker": "unverifiedBlocker__dACrQ",
	"card": "card__3DR58",
	"logo": "logo__2Z_t4",
	"title": "title__2nGWn",
	"body": "body__3VArq"
};
module.exports = exports;
